import { alpha } from '@material-ui/core/styles';

export const minimalScrollbar = (theme, options = {}) => {
  const isLightTheme = theme?.palette?.type === 'light';
  const {
    track = 'transparent',
    thumb = alpha(
      theme?.palette?.primary?.dark || theme?.palette?.primary?.main,
      isLightTheme ? 0.3 : 0.72
    ),
    thumbHover = alpha(
      theme?.palette?.primary?.main || theme?.palette?.primary?.light,
      isLightTheme ? 0.45 : 0.9
    ),
    size = 6,
  } = options;

  return {
    scrollbarColor: `${thumb} ${track}`,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      height: size,
      width: size,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: track,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumb,
      backgroundClip: 'content-box',
      border: '2px solid transparent',
      borderRadius: 999,
      minHeight: 24,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbHover,
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: track,
    },
  };
};
